import React from 'react'
import { string, node, array, number } from 'prop-types'

import ResponsiveImage from '../ResponsiveImage'
import ResponsiveMedia from '../ResponsiveMedia'
import Type from '../Type'
import Grid from '../Grid'
import TextAlign from '../TextAlign'
import Hide from '../Hide'

import styles from './ProfileHeader.module.scss'

const ProfileHeader = ({
  heading,
  subHeading,
  description,
  children,
  src,
  srcSet,
  imageRatio
}) => (
  <div className={styles.ProfileHeader}>
    <Grid flex gutter="default" middle>
      <Grid.Item hidden="mobile" width={{ d: 1 / 4 }}>
        <div className={styles.Image}>
          <ResponsiveMedia ratio={imageRatio}>
            <ResponsiveImage
              loading="eager"
              alt="Profile Picture"
              src={src}
              srcSet={srcSet}
              sizes={[
                '(min-width:1150px 220px',
                '(min-width:960px) 18vw',
                '100vw'
              ]}
            />
          </ResponsiveMedia>
        </div>
      </Grid.Item>
      <Grid.Item width={{ d: 1 / 2 }}>
        <div className={styles.Content}>
          <div className={styles.Heading}>
            <Type themed as="h1" size={['heading3', 'display1']} weight="bold">
              {heading}
            </Type>
          </div>
          {subHeading && (
            <div className={styles.SubHeading}>
              <Type themed as="h2" size={['body2', 'heading6']} weight="medium">
                {subHeading}
              </Type>
            </div>
          )}
          <Hide at="desktop">
            <div className={styles.Image}>
              <ResponsiveMedia ratio={imageRatio}>
                <ResponsiveImage
                  loading="eager"
                  alt="Profile Picture"
                  src={src}
                  srcSet={srcSet}
                  sizes={[
                    '(min-width:1150px 220px',
                    '(min-width:960px) 18vw',
                    '100vw'
                  ]}
                />
              </ResponsiveMedia>
            </div>
          </Hide>

          {description && (
            <div
              className={styles.Description}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
        </div>
      </Grid.Item>
      <Grid.Item width={{ d: 1 / 4 }}>
        <div className={styles.Links}>
          <TextAlign right>{children}</TextAlign>
        </div>
      </Grid.Item>
    </Grid>
  </div>
)

ProfileHeader.propTypes = {
  heading: string,
  subHeading: string,
  description: string,
  children: node,
  src: string,
  srcSet: array,
  imageRatio: number
}

export default ProfileHeader
